import { useState, useContext } from 'react'
import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { DataContext } from '../../contexts/dataContext'
import { Box, Flex } from 'rebass'
import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SearchRoundedIcon from '@material-ui/icons/SearchRounded'
import { BaseButton } from '../atoms/Buttons'
import { lang } from '../../utils/lang'
import { useFetch } from '../../hooks/useFetch'
import { BASE_URL } from '../../utils/constants'

const StyledFlex = styled(Flex)`
  position: absolute;
  top: 4.5rem;
  left: 65px;
  display: ${(props) => (props.intro === 'open' ? 'none' : 'flex')};
  ${Mq.xs} {
    top: 1.25rem;
  }
`

const StyledP = styled.p`
  position: absolute;
  top: 4.5rem;
  left: 65px;
  font-size: 0.75rem;
  ${Mq.xs} {
    top: 1.25rem;
  }
`

const SearchBox = styled(Box)`
  .MuiAutocomplete-popper {
    .MuiAutocomplete-listbox {
      color: ${(props) => props.theme.colors.white};
      background-color: ${(props) => props.theme.colors.ironBlue};
      max-height: 150px;
      font-size: 0.9rem;
    }
  }
`
const StyledSearch = styled(TextField)`
  position: relative;
  .MuiInputBase-root {
    background-color: ${(props) => props.theme.colors.ironBlue};
    height: 30px;
    color: ${(props) => props.theme.colors.white};
    font-size: 0.9rem;
    padding-right: 0;
  }
  .MuiInputBase-input {
    color: ${(props) => props.theme.colors.white};
    padding: 5px 4.5px;
  }
  .MuiOutlinedInput-root {
    border-radius: 50px;
    border: 1px solid ${(props) => props.theme.colors.white};
  }
  .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {
    padding: 0 9px;
  }
  .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']
    .MuiAutocomplete-input {
    padding: 4.5px 4px;
  }
  .MuiIconButton-root {
    color: ${(props) => props.theme.colors.white};
  }
`
const StyledButton = styled(BaseButton)`
  background-color: transparent;
  //padding-top: 12px;
  margin-top: -6px;
  svg {
    fill: white;
    width: 30px;
    height: 30px;
  }
  &:hover {
    svg {
      fill: ${(props) => props.theme.colors.aqua};
    }
  }
`
const Search = ({ handlePersonId, handleModal }) => {
  const { ui, intro } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const uiLang = ui === 'fa' ? 'fa/' : ''
  const [searchValue, setSearchValue] = useState('')
  const q1 = `${BASE_URL}/${uiLang}omiddata/getperson?viol_id=21&fields=fnames,sname,viol_coordinates`
  const q2 = `${BASE_URL}/${uiLang}omiddata/getperson?nonfatal=1&fields=fnames,sname,viol_coordinates,non_fatal`

  const { data, error } = useFetch(q1)
  const { data: nonFatalData, error: nonFatalError } = useFetch(q2)
  let uniqueNames
  if (data && nonFatalData) {
    const namesArray = []

    for (const [key, value] of Object.entries(data)) {
      if (value.viol_coordinates) {
        namesArray.push({
          label:
            value.sname && value.fnames
              ? `${value.sname}${lang[ui]['Comma']} ${value.fnames}`
              : value.sname
              ? `${value.sname}`
              : value.fnames
              ? `${value.fnames}`
              : lang[ui]['UnknownPerson'],
          id: +key
        })
      }
    }
    for (const [key, value] of Object.entries(nonFatalData)) {
      value.non_fatal.forEach((threat, i) => {
        //check to see threats have coordinates -- need at least one to have coordinates to make it searchable
        if (value.non_fatal[i].viol_coordinates) {
          namesArray.push({
            label:
              value.sname && value.fnames
                ? `${value.sname}, ${value.fnames}`
                : value.sname
                ? `${value.sname}`
                : value.fnames
                ? `${value.fnames}`
                : lang[ui]['UnknownPerson'],
            id: +key
          })
        }
      })
    }
    const sortedNames = namesArray.sort((a, b) =>
      a.label.localeCompare(b.label, ui)
    )
    const ids = sortedNames.map((o) => o.id)
    uniqueNames = sortedNames.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    )
  }

  const handleSearch = () => {
    handlePersonId(searchValue.id)
    handleModal()
  }
  // if (loading) return <StyledP>{lang[ui]['LoadingSearch']}</StyledP>
  if (error || nonFatalError)
    return <StyledP> {lang[ui]['ErrorSearch']}</StyledP>

  return (
    <StyledFlex intro={intro}>
      <SearchBox dir={dir}>
        <Autocomplete
          disablePortal
          onChange={(event, newValue) => {
            setSearchValue(newValue)
          }}
          id="combo-box-demo"
          options={uniqueNames}
          getOptionLabel={(option) => option.label}
          style={{ width: 250 }}
          popupIcon={<ExpandMoreIcon />}
          renderInput={(params) => (
            <StyledSearch
              {...params}
              placeholder={lang[ui]['Enter']}
              variant="outlined"
            />
          )}
        />
      </SearchBox>

      <StyledButton onClick={handleSearch}>
        <SearchRoundedIcon />
      </StyledButton>
    </StyledFlex>
  )
}

export default Search
